// @flow
import {connect} from "react-redux";
import {closeUnlockEBadgeModalAction, eBadgeUnlockAction} from "../../actions/ebadge/creators/eBadgeUnlockActionCreator";
import type {StoreState} from "../../reducers/combinedReducers";
import type {UnlockEBadgeModalDispatchProps, UnlockEBadgeModalStateProps} from "../../components/ebadge/UnlockEBadgeModal";
import UnlockEBadgeModal from "../../components/ebadge/UnlockEBadgeModal";
import {extractCaller} from "../QueryPage";
import type {Caller} from "../../components/QueryPage";

/**
 * Created by Mike Chung on 2/13/18.
 */

function getIsLoadingStatus(state, registrationCode) {
    let eBadgeUnlockStatus = state.eBadgeAction.unlock[registrationCode];
    if (eBadgeUnlockStatus) {
        return eBadgeUnlockStatus.isLoading;
    } else {
        return false;
    }
}


const mapStateToProps = (state: StoreState): UnlockEBadgeModalStateProps => {

    const isLoading = state.eBadgeAction.unlock.modal.registrationCode ? getIsLoadingStatus(state, state.eBadgeAction.unlock.modal.registrationCode)
                                                                : false;
    return {
        open: state.eBadgeAction.unlock.modal.open,
        registrationCode: state.eBadgeAction.unlock.modal.registrationCode,
        isLoading,
        error: state.eBadgeAction.unlock.error,
        caller: extractCaller(state)
    }
};

const mapDispatchToProps = (dispatch): UnlockEBadgeModalDispatchProps => {
    return {
        unlockEBadge: (registrationCode, caller: Caller) => {
            dispatch(eBadgeUnlockAction(registrationCode, caller));
        },
        closeModal: () => {
            dispatch(closeUnlockEBadgeModalAction());
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(UnlockEBadgeModal);



// WEBPACK FOOTER //
// ./src/containers/ebadge/UnlockEBadgeModal.js